"use client";

export default function DeleteIcon({ className = "", ...props }) {
  return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}
        {...props} >
<path d="M32.6357 11.8372L30.316 33.3204C30.316 34.0861 29.6898 34.7122 28.9241 34.7122H10.5377C9.77201 34.7122 9.14587 34.0861 9.14587 33.3204L6.82611 11.8372" stroke="currentColor" strokeWidth="2.26318" strokeMiterlimit="10"/>
<path d="M4.51392 9.20056H34.9461" stroke="currentColor" strokeWidth="2.26318" strokeMiterlimit="10"/>
<path d="M14.4229 4.74966H25.039" stroke="currentColor" strokeWidth="2.26318" strokeMiterlimit="10"/>
<path d="M16.4597 17.6139V28.5658" stroke="currentColor" strokeWidth="2.26318" strokeMiterlimit="10"/>
<path d="M23.0003 17.6139V28.5658" stroke="currentColor" strokeWidth="2.26318" strokeMiterlimit="10"/>
</svg>

  );
}


